module.exports = __webpack_public_path__ + "static/media/tracklocation.84960daf.svg";